type LibraryTrack = { id: string; sourceType: string; metadata?: Record<string, any> };

/** The catalogue cache also contains search/playback context. Only deliberate
 * saves belong to the user's library. Old records are kept, never deleted. */
export function migrateLibraryMembership<T extends LibraryTrack>(tracks: T[], favorites: string[] = [], playlists: { trackIds: string[] }[] = []): T[] {
  const saved = new Set([...favorites, ...playlists.flatMap(playlist => playlist.trackIds || [])]);
  return tracks.map(track => track.sourceType !== 'online' || typeof track.metadata?.libraryOwned === 'boolean' ? track : {
    ...track, metadata: { ...track.metadata, libraryOwned: saved.has(track.id) },
  });
}

export function isLibraryTrack(track: LibraryTrack): boolean {
  return track.sourceType !== 'online' || track.metadata?.libraryOwned === true;
}
